// import * as firebase from 'firebase/app';
import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABZ0mHtd0VFKb-lEZleDc7Pet91AYPf-U",
  authDomain: "boxgreen.firebaseapp.com",
  databaseURL: "https://boxgreen.firebaseio.com", 
  storageBucket: 'boxgreen.appspot.com', 
  projectId: "boxgreen",
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

// var storage = firebase.storage();

export default firebase;
// export const FB = firebase;
// export const Fire = firebase.initializeApp(firebaseConfig);
// export const db = firebase.firestore();

// export default Fire;